import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '@shared/services/notification.service';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-scim-token-dialog',
	standalone: false,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './scim-token-dialog.component.html',
})
export class ScimTokenDialogComponent implements OnDestroy {
	private destroy$ = new Subject<void>();

	constructor(
		@Inject(MAT_DIALOG_DATA) public token: string,
		public dialogRef: MatDialogRef<ScimTokenDialogComponent>,
		private notificationService: NotificationService,
	) {}

	copyToClipboard(): void {
		if (!navigator.clipboard) {
			this.notificationService.notify(['scim-administration.token.copy.error.header'], ['scim-administration.token.copy.error.content'], 'error');
			return;
		}

		navigator.clipboard
			.writeText(this.token)
			.then(() => {
				this.notificationService.notify(['scim-administration.token.copy.success.header'], ['scim-administration.token.copy.success.content'], 'success');
			})
			.catch(() => {
				this.notificationService.notify(['scim-administration.token.copy.error.header'], ['scim-administration.token.copy.error.content'], 'error');
			});
	}

	onClose(): void {
		this.dialogRef.close();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
